module.exports = "<div class=\"onBoardingDialog-bannerContainer\">\r\n    <!-- title message -->\r\n    <img class=\"onBoardingDialog-banner\" ng-src=\"{{$ctrl.onBoardingService.bannerUrl}}\" />\r\n</div>\r\n<div class=\"onBoardingDialog-content\" ng-bind-html=\"$ctrl.onBoardingService.content | sanitize\">\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/onboarding/onboarding-dialog-content.component.html
// module id = 368
// module chunks = 0 1